module.exports = __webpack_public_path__ + "static/img/demo-dialog-2.5a5704b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/demo-dialog-2.png
// module id = e6e5
// module chunks = 1